import { icons } from "../../../components/html";
import { note } from "../../../components/html";

export default {
  summary: "Get token for administration tasks - Client Credentials Grant",
  description: {
    summary: `Provides access and recovery token for endpoints marked with ${icons.u}. Suitable for long-term login - possibility to renew the token validity. It complies with RFC 6749 4.1`,
    contentFormat: `Content must be in format \`application/json\` or \`application/x-www-form-urlencoded\`. The format must be specified in header \`Content-Type\`.`,
    clientSecretNote: note(
      `Parameter \`client_secret\` must not be freely accessible. It serves as the access password to your API`
    )
  }
};
